import { Antwoord, Vraag, VariableContent } from '@models/claims';
import { VraagboomAntwoord, VraagboomReparateurResultaat, } from '@models/vragenboom';
import { VariableHelper } from './variable-helper';

export class SingleChoiceRepairMapper {
  public static mapResultaten(vraagboomAntwoord: VraagboomAntwoord<VraagboomReparateurResultaat>,
    variabeleContent: VariableContent[], vragen: Vraag[]) {
    if (vraagboomAntwoord == null || variabeleContent == null || vragen == null) {
      return;
    }

    const vraag: Vraag = new Vraag();
    if (vraagboomAntwoord.vraag != null) {
      vraag.id = vraagboomAntwoord.vraag.id;
      vragen.push(vraag);
    }

    if (vraagboomAntwoord.resultaat != null && vraagboomAntwoord.antwoorden != null && vraagboomAntwoord.antwoorden.length === 1) {
      vraag.antwoorden.push(new Antwoord({ id: vraagboomAntwoord.antwoorden[0].id }));

      if (vraagboomAntwoord.antwoorden[0].variabeleWaarden?.length > 0) {
        for (const varb of vraagboomAntwoord.antwoorden[0].variabeleWaarden) {
          const variable: string = VariableHelper.extractVariable(varb);
          if (variable.toLowerCase().startsWith('rel')) {
            variabeleContent.push(new VariableContent(vraagboomAntwoord.vraag.id, vraagboomAntwoord.antwoorden[0].id, variable, vraagboomAntwoord.resultaat.relatienummer));
          } else {
            variabeleContent.push(new VariableContent(vraagboomAntwoord.vraag.id, vraagboomAntwoord.antwoorden[0].id, variable, vraagboomAntwoord.resultaat.rol));
          }
        }
      }
    }
  }
}
